var render, staticRenderFns
import script from "./NoteExpansion.vue?vue&type=script&lang=js"
export * from "./NoteExpansion.vue?vue&type=script&lang=js"
import style0 from "./NoteExpansion.vue?vue&type=style&index=0&id=0c316a82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c316a82",
  null
  
)

export default component.exports